import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import AccountsPanel from '../components/admin/AccountsPanel';
import DocumentImportPanel from '../components/admin/DocumentImportPanel';
import DocumentAccessPanel from '../components/admin/DocumentAccessPanel';
import GroupsPanel from '../components/admin/GroupsPanel';

// Page d'administration — le contenu affiché dépend du rôle :
// - Super Administrateur : Comptes (tous rôles) + Import de documents + Accès + Groupes (pouvoir total)
// - Administrateur : Comptes (3 niveaux) + Accès aux documents + Groupes (lecture seule sur le SCADA)
export default function Admin() {
  const { isSuperAdmin, roleLabel } = useAuth();

  const tabs = [
    { key: 'accounts', label: 'Comptes' },
    ...(isSuperAdmin ? [{ key: 'import', label: 'Import de documents' }] : []),
    { key: 'access', label: 'Accès aux documents' },
    { key: 'groups', label: 'Groupes' },
  ];

  const [activeTab, setActiveTab] = useState(tabs[0].key);

  return (
    <div className="admin-page">
      <div className="home-header">
        <h1>Administration</h1>
        <p>
          {isSuperAdmin
            ? 'Super Administration — accès complet à la plateforme MEA PULSE'
            : `Administration — ${roleLabel}`}
        </p>
        <span className="scada-badge">S C A D A</span>
      </div>

      <div className="admin-tabs">
        {tabs.map((t) => (
          <button
            key={t.key}
            className={activeTab === t.key ? 'admin-tab active' : 'admin-tab'}
            onClick={() => setActiveTab(t.key)}
          >
            {t.label}
          </button>
        ))}
      </div>

      <div className="admin-tab-content">
        {activeTab === 'accounts' && <AccountsPanel />}
        {activeTab === 'import' && isSuperAdmin && <DocumentImportPanel />}
        {activeTab === 'access' && <DocumentAccessPanel />}
        {activeTab === 'groups' && <GroupsPanel />}
      </div>
    </div>
  );
}